import React, { useState } from 'react';
import { shallow } from 'zustand/shallow';
import useDashboardStore from '../store/dashboardStore';
import Skeleton from './Skeleton';
import EmptyState from './EmptyState';

const TopProducts = () => {
  const { topProducts, products, searchProducts, productsLoading } = useDashboardStore(
    (state) => ({
      topProducts: state.topProducts,
      products: state.products,
      searchProducts: state.searchProducts,
      productsLoading: state.productsLoading,
    }),
    shallow,
  );
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearching, setIsSearching] = useState(false);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      searchProducts(searchQuery);
      setIsSearching(true);
    } else {
      setIsSearching(false);
    }
  };

  const handleClearSearch = () => {
    setSearchQuery('');
    setIsSearching(false);
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchQuery(value);
    if (!value.trim()) {
      setIsSearching(false);
    }
  };

  const baseProducts = (isSearching ? products : topProducts) ?? [];

  const displayProducts = baseProducts.slice(0, 5);

  return (
    <div className="products-table">
      <div className="table-header">
        <h3 className="table-title">Top Products</h3>
        <form onSubmit={handleSearch} style={{ display: 'flex', gap: '10px' }} role="search" aria-label="Search top products">
          <label htmlFor="top-products-search" className="sr-only">Search products</label>
          <input
            id="top-products-search"
            type="text"
            placeholder="Search products..."
            value={searchQuery}
            onChange={handleSearchChange}
            style={{
              padding: '8px 12px',
              background: 'rgba(102, 126, 234, 0.1)',
              border: '1px solid rgba(102, 126, 234, 0.3)',
              borderRadius: '8px',
              color: 'white',
              fontSize: '0.9rem',
            }}
          />
          <button
            type="submit"
            className="quantum-btn"
            style={{ padding: '8px 16px', fontSize: '0.9rem' }}
          >
            Search
          </button>
          {isSearching && (
            <button
              type="button"
              onClick={handleClearSearch}
              aria-label="Clear search results"
              style={{
                padding: '8px 12px',
                background: 'rgba(239, 68, 68, 0.15)',
                border: '1px solid rgba(239, 68, 68, 0.3)',
                borderRadius: '8px',
                color: '#f87171',
                cursor: 'pointer',
              }}
            >
              Clear
            </button>
          )}
        </form>
      </div>

      <div className="products-list">
        {isSearching && productsLoading ? (
          <Skeleton lines={6} />
        ) : displayProducts.length > 0 ? (
          <table>
            <thead>
              <tr>
                <th>Product</th>
                <th>Price</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {displayProducts.map((product, index) => (
                <tr key={index}>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      {product.image_url && (
                        <img
                          src={product.image_url}
                          alt={product.title || product.name || 'Product image'}
                          style={{
                            width: '40px',
                            height: '40px',
                            objectFit: 'cover',
                            borderRadius: '8px',
                            border: '1px solid rgba(102, 126, 234, 0.2)'
                          }}
                        />
                      )}
                      <div>
                        <div style={{ fontWeight: '500', marginBottom: '2px' }}>
                          {product.title || product.name || 'Unknown Product'}
                        </div>
                        <div style={{ fontSize: '0.85rem', color: 'rgba(255, 255, 255, 0.5)' }}>
                          {product.marketplace || 'Multiple Markets'}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span style={{
                      color: '#22c55e',
                      fontWeight: '600',
                      fontFamily: 'Orbitron, monospace'
                    }}>
                      ${product.price || '0.00'}
                    </span>
                  </td>
                  <td>
                    <span style={{
                      padding: '4px 8px',
                      background: 'rgba(34, 197, 94, 0.1)',
                      border: '1px solid rgba(34, 197, 94, 0.3)',
                      borderRadius: '6px',
                      fontSize: '0.85rem',
                      color: '#22c55e',
                    }}>
                      Active
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <EmptyState
            icon="📦"
            title="No top products yet"
            description="Try searching to populate results."
          />
        )}
      </div>
    </div>
  );
};

export default TopProducts;
